"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInstallStateWxwork = void 0;
/**
 * 判断企业微信下app是否安装
 * @param platform
 * @param packageName
 * @returns
 */
var getInstallStateWxwork = function (platform, packageName) {
    if (platform === void 0) { platform = 'android'; }
    console.log('>>> getInstallStateWxwork:', packageName);
    var PACKAGE_NAME = 'com.tencent.wemeet.app';
    return new Promise(function (resolve) {
        var param = {};
        if (platform === 'iphone') {
            param = {
                scheme: (packageName || 'wemeet://'),
            };
        }
        else {
            param = {
                packageName: (packageName || PACKAGE_NAME),
            };
        }
        console.log('>>> getInstallStateWxwork param:', param);
        window.wx.invoke('getInstallState', param, function (res) {
            resolve(res);
        });
    });
};
exports.getInstallStateWxwork = getInstallStateWxwork;
//# sourceMappingURL=tx-wxwork-jsbridge.js.map